module.exports = __webpack_public_path__ + "img/treppenhaus.fbf5e67b.jpg";